import React from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertFromRaw } from 'draft-js';
import Button from 'shared/button';

export type CustomCards = {
  customCards: CustomCardProps[];
}

export type CustomCardProps = {
  id: number;
  title: string;
  subtitle: string;
  body: string;
  preview?: boolean;
  editCard: () => void;
}

const TOOLBAR_SETTINGS = { link: { showOpenOptionOnHover: false }, options: [] };

export default function CustomCard(props: CustomCardProps) {
  const { body } = props;
  let editorState;
  if (body) {
    editorState = EditorState.createWithContent(convertFromRaw(JSON.parse(body)));
  } else {
    editorState = EditorState.createEmpty();
  }

  return (
    <div className="ds-client-report-card d-flex flex-column gap-4 p-4 ds-custom-card">
      <div className="d-flex flex-row justify-content-between">
        <h6 className="m-0 fw-normal">{props.title}</h6>
      </div>
      <h5>{props.subtitle}</h5>
      <div className="h-100 d-flex flex-column justify-content-between">
        <div className="ds-custom-card-body">
          <Editor
            editorState={editorState}
            readOnly
            toolbar={TOOLBAR_SETTINGS}
            toolbarHidden
          />
        </div>
        { !props.preview && (
          <div className="d-flex justify-content-end">
            <Button.Secondary className="ds-button--plain" style={{ cursor: 'pointer' }} onClick={props.editCard}>
              Edit
            </Button.Secondary>
          </div>
        )}
      </div>
    </div>
  );
}
